var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconComputer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 2,
    y: 3,
    width: 20,
    height: 11,
    fill: "#FCFCFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.61183 17.6687H9.13857L8.90681 19.2131H8.0154C7.52512 19.2131 7.12399 19.6262 7.12399 20.1111C7.12399 20.587 7.52512 21 8.0154 21H15.9757C16.4749 21 16.8671 20.587 16.8671 20.1111C16.8671 19.6262 16.4749 19.2131 15.9757 19.2131H15.0843L14.8614 17.6687H20.3793C22.0818 17.6687 23 16.7798 23 15.0378V4.63091C23 2.88894 22.0818 2 20.3793 2H3.61183C1.90924 2 1 2.88894 1 4.63091V15.0378C1 16.7798 1.90924 17.6687 3.61183 17.6687ZM3.33549 13.3318C3.0859 13.3318 2.97002 13.233 2.97002 12.9636V4.81049C2.97002 4.20888 3.22853 3.97543 3.79011 3.97543H20.201C20.7715 3.97543 21.03 4.20888 21.03 4.81049V12.9636C21.03 13.233 20.9141 13.3318 20.6645 13.3318H3.33549ZM12 16.7528C11.4919 16.7528 11.0818 16.3398 11.0818 15.837C11.0818 15.3341 11.4919 14.9121 12 14.9121C12.4992 14.9121 12.9092 15.3341 12.9092 15.837C12.9092 16.3398 12.4992 16.7528 12 16.7528Z",
    fill: "#FCFCFC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconComputer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-computer.c29146a22dab0e1fbeddb2a13db67577.svg";